import React from 'react'

const Heading = ({ customClass, text }) => {
    return (
        <h2 className={`c15 tac mb1rem ${customClass}`}>{text}</h2>
    )
}

export default Heading